import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  AiTwotoneIdcard,
  AiTwotoneFileImage,
  AiTwotoneNotification,
  AiTwotoneInfoCircle,
  AiTwotoneMail,
  AiTwotoneSecurityScan,
  AiFillNotification,
} from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import { RxHamburgerMenu } from "react-icons/rx";
import { changeLangFunc, changeModeFunc } from "../redux/actions";
import "./Navbar.css";
import { FiSun, FiMoon } from "react-icons/fi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGuitar, faTent, faHeadset } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";

const Navbar = (props) => {
  // const [menu, setMenu] = React.useState(false);
  // const dispatch = useDispatch();
  // const [dropdown, setDropdown] = React.useState(false);
  const dropRef = React.useRef(null);

  const lang = useSelector((state) => state.reducer1.lang);
  const mode = useSelector((state) => state.reducer1.mode);

  const menuTab = React.useRef(null);
  const aboutInfo = React.useRef(null);

  function toggle() {
    // setTog(!tog);
    if (lang === "en") {
      document.getElementById("enBtnNav").style.backgroundColor = "transparent";
      document.getElementById("jpBtnNav").style.backgroundColor = "#192F83";
      document.getElementById("enBtnNav").style.color = "#192F83";
      document.getElementById("jpBtnNav").style.color = "white";
    } else {
      document.getElementById("enBtnNav").style.backgroundColor = "#192F83";
      document.getElementById("jpBtnNav").style.backgroundColor = "transparent";
      document.getElementById("enBtnNav").style.color = "white";
      document.getElementById("jpBtnNav").style.color = "#192F83";
    }
  }

  useEffect(() => {
    if (lang === "jp") {
      document.getElementById("enBtnNav").style.backgroundColor = "transparent";
      document.getElementById("jpBtnNav").style.backgroundColor = "#192F83";
      document.getElementById("enBtnNav").style.color = "#192F83";
      document.getElementById("jpBtnNav").style.color = "white";
    } else {
      document.getElementById("enBtnNav").style.backgroundColor = "#192F83";
      document.getElementById("jpBtnNav").style.backgroundColor = "transparent";
      document.getElementById("enBtnNav").style.color = "white";
      document.getElementById("jpBtnNav").style.color = "#192F83";
    }
  }, []);

  const dispatch = useDispatch();

  return (
    <div style={{ position: "absolute", zIndex: "100", width: "100vw" }}>
      <nav style={{ display: "flex", alignItems: "center" }}>
        <div style={{ display: "grid", placeItems: "center" }}>
          {mode == "day" ? (
            <img src="/img/logo-b.png" alt="" />
          ) : (
            <img src="/img/logo-w.png" alt="" />
          )}
          {lang === "en" ? (
            <p
              className="klee-one-regular"
              style={{
                color: mode == "day" ? "black" : "white",
                fontSize: ".8rem",
                position: "relative",
                // top: "-8em"
              }}
            >
              - Make the Region -
            </p>
          ) : (
            <p
              className="klee-one-regular"
              style={{ color: "black", fontSize: ".8rem" }}
            >
              - 地域を作る -
            </p>
          )}
        </div>

        {/* {menu && ( */}
        <div
          className="menu"
          style={{
            marginLeft: "auto",
            // display: "flex",
            position: "relative",
            // top:"3rem",
            // right:"5rem",
            alignItems: "center",
            // border: "2px solid red",
          }}
        >
          <AiTwotoneIdcard
            style={{ width: "2.5rem", height: "2.5rem", marginRight: ".5rem" }}
          />
          <div
            // onClick={() => {
            //   props.goToAbout();
            // }}
            onMouseOver={() => {
              if (dropRef) {
                dropRef.current.style.display = "block";
              }
            }}
            onMouseLeave={() => {
              if (dropRef) {
                dropRef.current.style.display = "none";
              }
            }}
            className="luckiest-guy-regular"
            style={{
              position: "relative",
              color: mode == "day" ? "#192F83" : "white",
            }}
            // style={{ color: mode == "day" ? "#192F83" : "white" }}
          >
            {lang === "en" ? "ABOUT US" : "私たちについて"}
            <div
              ref={dropRef}
              style={{
                display: "none",
                position: "absolute",
                paddingTop: "1rem",
                // border:"1px solid black",
              }}
            >
              <p
                onClick={() => {
                  props.goToAboutPhilosophy();
                }}
                className="drop"
              >
                <IoIosArrowForward />
                {lang === "en" ? "Philosophy" : "哲学"}
              </p>
              <p
                onClick={() => {
                  props.goToAboutInfo();
                }}
                className="drop"
              >
                <IoIosArrowForward />
                {lang === "en" ? "Corporate Info" : "企業情報"}
              </p>
              <p
                onClick={() => {
                  props.goToAboutPartners();
                }}
                className="drop"
              >
                <IoIosArrowForward />
                {lang === "en" ? "Partners" : "パートナー"}
              </p>
              <p
                //  onClick={() => {
                //   props.goToAboutPartners();
                // }}
                className="drop"
              >
                <IoIosArrowForward />
                {lang === "en" ? "We are" : "私たちは"}
              </p>
            </div>
          </div>

          <AiTwotoneFileImage
            style={{ width: "2rem", height: "2rem", marginRight: ".5rem" }}
          />

          <p
            onClick={() => {
              props.goToPF();
            }}
            className="luckiest-guy-regular"
            style={{ color: mode == "day" ? "#192F83" : "white" }}
          >
            {lang === "en" ? "WORKS" : "作品"}
          </p>

          <AiTwotoneNotification
            style={{ width: "2rem", height: "2rem", marginRight: ".5rem" }}
          />
          <p
            onClick={() => {
              props.goToNewsPoster();
            }}
            className="luckiest-guy-regular"
            style={{ color: mode == "day" ? "#192F83" : "white" }}
          >
            {lang === "en" ? "News" : "ニュース"}
          </p>

          <AiTwotoneInfoCircle
            style={{
              width: "2rem",
              height: "2rem",
              marginRight: ".5rem",
              color: "white",
            }}
          />

          <p
            onClick={() => {
              props.goToGuide();
            }}
            className="luckiest-guy-regular"
            style={{ color: mode == "day" ? "#192F83" : "white" }}
          >
            {lang === "en" ? "Guide" : "ガイド"}
          </p>

          <AiTwotoneSecurityScan
            style={{
              width: "2rem",
              height: "2rem",
              marginRight: ".5rem",
              color: "white",
            }}
          />

          <p
            //  onClick={() => {
            //   props.goToGuide();
            // }}
            className="luckiest-guy-regular"
            style={{ color: mode == "day" ? "#192F83" : "white" }}
          >
            {lang === "en" ? "Recruit" : "リクルート"}
          </p>

          <AiTwotoneMail
            style={{ width: "2rem", height: "2rem", marginRight: ".5rem" }}
          />

          <p
            onClick={() => {
              props.goToNews();
            }}
            className="luckiest-guy-regular"
            style={{ color: mode == "day" ? "#192F83" : "white" }}
          >
            {lang === "en" ? "CONTACT US" : "お問い合わせ"}
          </p>
        </div>

        {/* Phone UI */}

        <main className="phoneMenu">
          <RxHamburgerMenu
            className="menuIcon"
            onClick={() => {
              menuTab.current.classList.toggle("menuTabShow");
            }}
          />

          <div ref={menuTab} className="menuTab">
            <div
              onClick={() => {
                aboutInfo.current.classList.toggle("aboutInfoShow");
              }}
              className="listItem"
            >
              <AiTwotoneIdcard className="phoneIcon" />
              <p>{lang === "en" ? "ABOUT US" : "私たちについて"}</p>
            </div>

            <div ref={aboutInfo} className="aboutInfo">
              <p
                onClick={() => {
                  props.goToAboutPhilosophy();
                }}
              >
                <IoIosArrowForward className="arrowIcon" />
                {lang === "en" ? "Philosophy" : "哲学"}
              </p>
              <p
                onClick={() => {
                  props.goToAboutInfo();
                }}
              >
                <IoIosArrowForward className="arrowIcon" />
                {lang === "en" ? "Corporate Info" : "企業情報"}
              </p>
              <p
                onClick={() => {
                  props.goToAboutPartners();
                }}
              >
                <IoIosArrowForward className="arrowIcon" />
                {lang === "en" ? "Partners" : "パートナー"}
              </p>
              <p>
                <IoIosArrowForward className="arrowIcon" />
                {lang === "en" ? "We are" : "私たちは"}
              </p>
            </div>

            <div
              onClick={() => {
                props.goToPF();
              }}
              className="listItem"
            >
              <AiTwotoneFileImage className="phoneIcon" />
              <p>{lang === "en" ? "WORKS" : "作品"}</p>
            </div>

            <div
              onClick={() => {
                props.goToNewsPoster();
              }}
              className="listItem"
            >
              <AiTwotoneNotification className="phoneIcon" />
              <p>{lang === "en" ? "News" : "ニュース"}</p>
            </div>

            <div
              onClick={() => {
                props.goToGuide();
              }}
              className="listItem"
            >
              <AiTwotoneInfoCircle className="phoneIcon" />
              <p>{lang === "en" ? "Guide" : "ガイド"}</p>
            </div>

            <div
              // onClick={() => {
              //   props.goToGuide();
              // }}
              className="listItem"
            >
              <AiTwotoneSecurityScan className="phoneIcon" />
              <p>{lang === "en" ? "Recruit" : "リクルート"}</p>
            </div>

            <div
              onClick={() => {
                props.goToNews();
              }}
              className="listItem"
            >
              <AiTwotoneMail className="phoneIcon" />
              <p>{lang === "en" ? "CONTACT US" : "お問い合わせ"}</p>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "2rem",
                marginBottom: "2rem",
              }}
            >
              <div
                onClick={() => {
                  dispatch(changeLangFunc());
                  toggle();
                  if (lang === "en") {
                    Cookies.set("lang", "jp", { secure: true, expires: 7 });
                    document.title =
                    "イベント事例 | Regionport - 成功事例の紹介 - Works」";
                  } else {
                    Cookies.set("lang", "en", { secure: true, expires: 7 });
                    document.title =
                      "Event examples | Regionport - Introducing success stories - Works";
                  }
                }}
                className="interFont"
                style={{
                  // marginTop: "1rem",
                  // marginLeft: "auto",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.1rem",
                  cursor: "pointer",
                  marginRight: "1rem",
                  border: "2px solid black",
                  backgroundColor: "white",
                  borderRadius: "30px",
                  // position: "relative",
                  padding: "0.2rem",
                  // color: "white",
                  width: "fit-content",
                }}
              >
                <p
                  id="enBtnNav"
                  style={{
                    // marginRight: "0rem",
                    backgroundColor: "#192F83",
                    padding: "11px 8px 8px 8px",
                    borderRadius: "100%",
                    // color: "white",
                  }}
                >
                  EN
                </p>
                <p
                  id="jpBtnNav"
                  style={{
                    backgroundColor: "transparent",
                    padding: "9px 9px 7px 9px",
                    borderRadius: "100%",
                    color: "#192F83",
                  }}
                >
                  JP
                </p>
              </div>

              <div
                onClick={() => {
                  dispatch(changeModeFunc());
                }}
                style={{
                  color: "white",
                  marginLeft: "auto",
                  display: "grid",
                  placeItems: "center",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                  backgroundColor: "#192F83",
                  borderRadius: "100%",
                  padding: ".7rem",
                }}
              >
                {mode === "day" ? <FiSun /> : <FiMoon />}
              </div>
            </div>

            <div className="icons3Nav">
              <a
                href="#"
                style={{
                  // border:"2px solid red",
                  display: "grid",
                  placeItems: "center",
                  fontSize: "1.5rem",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  padding: "8px",
                  // marginRight: "1rem",
                }}
              >
                <FontAwesomeIcon
                  beatFade
                  className="fa-guitar"
                  icon={faTent}
                  color="lime"
                />
              </a>

              <a
                href="#"
                style={{
                  display: "grid",
                  placeItems: "center",
                  fontSize: "1.5rem",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  padding: "8px",
                  // marginRight: "1rem",
                  color: "white",
                  width: "1.7rem",
                }}
              >
                <div className="gg-instagram-one"></div>
              </a>

              <a
                href="#"
                style={{
                  display: "grid",
                  placeItems: "center",
                  fontSize: "1.5rem",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  padding: "8px",
                  // marginRight: "1rem",
                  width: "1.7rem",
                }}
              >
                <FontAwesomeIcon
                  className="fa-guitar"
                  icon={faHeadset}
                  size="xs"
                />
              </a>
            </div>
          </div>
        </main>

        {/* )} */}

        {/* {!menu && (
          <div
            onClick={() => {
              setMenu(!menu);
            }}
            style={{
              cursor: "pointer",
              marginLeft: "auto",
              marginRight: "1rem",
              fontSize: "3rem",
            }}
          >
            <RxHamburgerMenu />
          </div>
        )} */}

        {/* {menu && (
          <div
            onClick={() => {
              setMenu(!menu);
            }}
            style={{
              cursor: "pointer",
              // marginLeft: "auto",
              marginRight: "1rem",
              fontSize: "3rem",
            }}
          >
            <IoClose />
          </div>
        )} */}
      </nav>
    </div>
  );
};

export default Navbar;
